<section class="parent-container">
  <div class="mx-5 mb-10">
    <div class="container-top">
      <div class="container-title flex items-center justify-between">
        <h1>Cellular Usage</h1>
        <div class="flex items-center justify-between gap-2">
          <div
            class="flex h-14 items-center justify-center rounded-full bg-white px-4 pb-0.5 pt-2 lg:ml-2"
          >
            <app-toggle
              [disabled]="aggregatedLoading"
              [(ngModel)]="showMockData"
              (ngModelChange)="toggleMockData($event)"
              [label]="
                showMockData ? 'Switch to Real Data' : 'Switch to Sample Data'
              "
              size="md"
              color="primary"
            >
            </app-toggle>
          </div>
          <app-analytics-time-selector
            (selectedOptionChange)="onChildSelectionChange($event)"
          />
        </div>
      </div>
    </div>

    @if (!aggregatedIsNoContent) {
      <mat-grid-list cols="4" rowHeight="400px" gutterSize="20px">
        <mat-grid-tile colspan="1">
          <app-analytics-widget
            [isNoContent]="aggregatedIsNoContent"
            [loading]="aggregatedLoading"
            class="analytics-widget"
          >
            @if (!aggregatedLoading) {
              <app-data-consumption
                [highestDataConsumption]="highestDataConsumption"
                [totalDataConsumption]="totalDataConsumption"
              ></app-data-consumption>
            }
          </app-analytics-widget>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <app-analytics-widget
            [isNoContent]="aggregatedIsNoContent"
            [loading]="aggregatedLoading"
            class="analytics-widget"
          >
            @if (!aggregatedLoading) {
              <app-analytics-apex-chart-pie
                [series]="timeOfDayBreakdownData"
                [labels]="timeOfDayBreakdownLabels"
                [title]="timeOfDayBreakdownTitle"
              />
            }
          </app-analytics-widget>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <app-analytics-widget
            [isNoContent]="aggregatedIsNoContent"
            [loading]="aggregatedLoading"
            class="analytics-widget"
          >
            @if (!aggregatedLoading) {
              <app-analytics-apex-chart-bar
                [chartName]="top5DevicesCategoriesTitle"
                [data]="top5DevicesData"
                [categories]="top5DevicesCategories"
                [yTitle]="top5DevicesCategoriesYtitle"
              ></app-analytics-apex-chart-bar>
            }
          </app-analytics-widget>
        </mat-grid-tile>
      </mat-grid-list>
    }
  </div>

  <!-- <app-cellular-table
    [dataSource]="metricTableData"
    [loading]="tableLoading"
    [isNoContent]="tableIsNoContent"
  /> -->
</section>

